import React, {useState, useEffect} from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Typography, Card, Button } from '@mui/material';
import dayjs from 'dayjs';
import { useActivityQuery } from '../services/dvagent'
import { getToken, storeAdmin, removeToken } from '../services/LocalStorageService';
import { Toaster } from '../sections/@dashboard/attributes';

export default function UserActivity() {
  const location = useLocation();
  const navigate = useNavigate();
  const [log, setLog] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const itemsToShow = showAll ? log.length : 5;
  const { data:activityData, isSuccess:activityIsSuccess, error:activityError } = useActivityQuery({"token":getToken(), "location":location});
  const [toasterData, setToasterData] = useState({
    trigger: false,
    status: true,
    symbol: '✔',
    message: '',
  });

  useEffect(() => {
    if (activityError) {
      if (activityError.status === 401) {
        // showToast(false, 'ⓘ', 'Unauthorized User');
        storeAdmin("false");
        removeToken();
        navigate('/');
      } else {
        showToast(false, 'ⓘ', 'Something went wrong, server error');
      }
    }
    if (activityData && activityIsSuccess) {
      setLog(activityData.log)
    }
  }, [activityData, activityIsSuccess, activityError]);  

  const showToast = (status, symbol, message) => {
    setToasterData({
      trigger: true,
      status,
      symbol,
      message,
    });

    setTimeout(() => {
      setToasterData((prev) => ({
        ...prev,
        trigger: false,
      }));
    }, 5000); 
  };
  return (
    <>
      <Helmet>
        <title> DV Agent </title>
      </Helmet>
      {toasterData.trigger && (
        <Toaster
          trigger={toasterData.trigger}
          status={toasterData.status}
          symbol={toasterData.symbol}
          message={toasterData.message}
        />
      )}
      <Container maxWidth="xxl">
        <Typography variant="h6" color="text.secondary" sx={{ mb: 5 }}>
          Activity Log 
        </Typography>
          {log.length > 5 && (
            <Button 
              variant="text"
              onClick={() => setShowAll(!showAll)}
              sx={{
                color: '#A8A196'
              }}>
              {showAll ? 'Less' : 'More'}
            </Button>
          )}
          {log.slice(0, itemsToShow).map((item) => (
            <Card sx={{ marginBottom: 1 }} key={item.id}>
              <Typography variant="" component="div" sx={{ fontSize: '90%', padding: 2, verticalAlign: 'middle' }}>
                [&nbsp;{dayjs(item.created_on).format('YYYY-MM-DD HH:mm:ss')}&nbsp;]&nbsp;&nbsp;&nbsp;&nbsp;{item.action}
              </Typography>
            </Card>
          ))}
      </Container> 
    </>
  );
}

